import listActions from 'src/modules/perfilEmpleado/list/perfilEmpleadoListActions';
import PerfilEmpleadoService from 'src/modules/perfilEmpleado/perfilEmpleadoService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'PERFILEMPLEADO_DESTROY';

const perfilEmpleadoDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: perfilEmpleadoDestroyActions.DESTROY_STARTED,
      });

      await PerfilEmpleadoService.destroyAll([id]);

      dispatch({
        type: perfilEmpleadoDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.perfilEmpleado.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/perfil-empleado');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: perfilEmpleadoDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: perfilEmpleadoDestroyActions.DESTROY_ALL_STARTED,
      });

      await PerfilEmpleadoService.destroyAll(ids);

      dispatch({
        type: perfilEmpleadoDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.perfilEmpleado.destroyAll.success'),
      );

      getHistory().push('/perfil-empleado');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: perfilEmpleadoDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default perfilEmpleadoDestroyActions;
